import { render } from "./marketImpactScreen.vue?vue&type=template&id=d3d35476&scoped=true"
import script from "./marketImpactScreen.vue?vue&type=script&lang=js"
export * from "./marketImpactScreen.vue?vue&type=script&lang=js"

import "./marketImpactScreen.vue?vue&type=style&index=0&id=d3d35476&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d35476"]])

export default __exports__